import React, { useEffect, useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import { OrganizationTypes } from '@/common/constants';
import { TotalSpendDashboardContainer } from '@/modules/AccountUsageDashboard';
import { EmployerStatus } from '@/modules/employer/employer.constants';

import { useCurrentOrganization, useHistory } from '../hooks';

import DashboardModals from './DashboardModals/DashboardModals';
import NewStatistics from './NewStatistics';
import OrganizationBanner from './OrganizationBanner';
interface Props {
  bannerNode?: React.ReactNode;
}
const Dashboard: React.FC<Props> = ({ bannerNode }) => {
  const { removeAllQueryParamsExceptOwn } = useHistory();
  useEffect(() => {
    removeAllQueryParamsExceptOwn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const {
    observingOrganization: { type, status },
  } = useCurrentOrganization();

  const isPendingOrganization = useMemo(() => {
    return (
      status === EmployerStatus.Pending ||
      status === EmployerStatus.PendingReactivation ||
      status === EmployerStatus.PendingTermination
    );
  }, [status]);
  const isSystemLevel = useMemo(() => type === OrganizationTypes.system, [type]);
  const isPartnerLevel = useMemo(() => type === OrganizationTypes.partner, [type]);
  return (
    <Box data-testid="dashboard_with-banner" direction="column" gap="spacing24">
      <OrganizationBanner />

      {!isSystemLevel && !isPartnerLevel && <Box>{bannerNode}</Box>}
      <NewStatistics />

      {!isPendingOrganization && <TotalSpendDashboardContainer />}
      <DashboardModals />
    </Box>
  );
};
export default Dashboard;
